/**
 * バンドルミックスマッチ設定画面　値引き商品VOクラス
 */
export class KYMW1308DiscountGoodsModel {
  // Ｐコード
  public pCode: string = <string>'';

  // 今回供給価格（いばらき）
  public thisTimeSupplyPriceIB: string = <string>'';

  // 今回供給価格（とちぎ）
  public thisTimeSupplyPriceTO: string = <string>'';

  // 今回供給価格（ぐんま）
  public thisTimeSupplyPriceGU: string = <string>'';

  // 今回供給価格（ちば）
  public thisTimeSupplyPriceTI: string = <string>'';

  // 今回供給価格（さいたま）
  public thisTimeSupplyPriceSA: string = <string>'';

  // 今回供給価格（とうきょう）
  public thisTimeSupplyPriceTK: string = <string>'';

  // 今回供給価格（ながの）
  public thisTimeSupplyPriceNA: string = <string>'';

  // 今回供給価格（にいがた）
  public thisTimeSupplyPriceNI: string = <string>'';

  // 項番2059 START
  // 今回供給価格（クルコ）
  public thisTimeSupplyPriceKU: string = <string>'';
}
